import { Capacitor } from '@capacitor/core';

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function platform(): 'ios' | 'android' | 'web' {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
}

export const isIOS = () => platform() === 'ios';
export const isAndroid = () => platform() === 'android';

/**
 * Whether the running native binary actually contains a plugin. In the hosted-
 * WebView model the JS updates instantly for every user, but native plugins
 * only arrive with a store update — so a plugin referenced by fresh JS is
 * routinely absent from older binaries in the field. Check this before calling
 * a recently-added plugin instead of letting the bridge throw "not implemented".
 */
export const hasNativePlugin = (name: string) => Capacitor.isPluginAvailable(name);
